import { Injectable } from "@angular/core";
import { CommandService, Flow, HasCommands, Reloadable } from "../../command/command.service";
import { CommandInput, CommandTemplate } from "../../../entities/commandTemplate/commandTemplate";
import { IssueViewComponent } from "../../../components/issue-view/issue-view.component";
import { IssueInput } from "../../../entities/issue/issueInput";

@Injectable({
  providedIn: 'root'
})
export class IssueUpdateCommandCustomFlow implements Flow {
  async executeFlow(commandService: CommandService, hasCommands: HasCommands,
    commandTemplate: CommandTemplate, commandInput: CommandInput,
    completionCallback: () => void, reloadable?: Reloadable): Promise<any> {

      console.log(commandTemplate);
    if (reloadable instanceof IssueViewComponent) {
      try {
        // Enter edit mode and wait for result
        const result = await reloadable.enterEditMode();

        if (result.action === 'save') {
          // Handle save logic
          console.log('User saved:', result.data);
          const issueInput = new IssueInput();
          issueInput.id = hasCommands.getEntityId();
          issueInput.title = result.data.title;
          issueInput.description = result.data.description;
          commandInput.addParameter("issueInput", result.data);
          commandInput.addParameter("commandProviderId", hasCommands.getEntityId());

          console.log("IssueCreateCommandCustomFlow.executeFlow result", result);
          commandService.sendCommand(commandInput, () => {
            completionCallback();
          })
        } else {
          // Handle cancel logic
          console.log('User cancelled');
        }
        completionCallback();
      } catch (error) {
        console.error('Edit mode failed:', error);
        completionCallback();
      }
    }
  }
}
